import {config} from "./config";
import {request} from "./request";

function createTaoLijin(data, cb, fail_cb) {
    request.post.call(this, config.apiList.taolijins, data, {}, cb, fail_cb)
}

function getTaoLijins(data, cb, fail_cb) {
    request.get.call(this, config.apiList.taolijins, data, cb, fail_cb)
}

var taobaoApi = {
    createTaoLijin: createTaoLijin,
    getTaoLijins: getTaoLijins
}

export {taobaoApi}